import type { SignUpFormValues } from '../schemas';
import type { FieldValues, UseFormReturn } from 'react-hook-form';

import { defaultValues } from '../hooks/sign-up-form';
import { signUpManager } from '../models';

/**
 * Answers that only exist inside the business branch of the sign up flow.
 */
export const businessFields = [
  'structure',
  'abn',
  'businessName',
  'roleInBusiness',
  'companyName',
  'acn',
  'roleInCompany',
  'trustName',
  'trustType',
  'isEmployee',
] as const satisfies readonly (keyof SignUpFormValues)[];

/**
 * Drop every answer collected in the business branch.
 *
 * Steps navigate by URL and "Go back" is a history pop, so the form is never reset
 * between steps. Without this a user who picks a business structure, goes back and then
 * continues as an individual keeps a stale structure, and would re-enter the business
 * branch with the structure and ABN steps already answered (PWA-16156).
 *
 * Uses `setValue` rather than `resetField`, which no-ops for fields the user never
 * reached and so never registered.
 *
 * @param form - The sign up form
 */
export function resetBusinessFields(
  form: Pick<UseFormReturn<FieldValues>, 'setValue' | 'clearErrors'>,
) {
  for (const field of businessFields) {
    form.setValue(field, defaultValues[field]);
  }

  form.clearErrors([...businessFields]);
  signUpManager.userDeclaredNoAbn = null;
}
